import { useCallback, useLayoutEffect, useRef } from 'react';
/**
 * Выдвигает за текст первую иконку в многострочном режиме,
 * устанавливая CSS-переменную, которая используется для вычисления padding и margin.
 */
export function useLeadingIcon(_ref) {
  var allowIconLeading = _ref.allowIconLeading,
    beforeIcon = _ref.beforeIcon,
    inline = _ref.inline;
  var linkRef = useRef(null);
  var beforeIconRef = useRef(null);
  var resetIconLeading = useCallback(function () {
    if (typeof window !== 'undefined' && linkRef.current) {
      linkRef.current.style.setProperty('--leading-icon-indent', '0');
    }
  }, []);
  var setIconLeading = useCallback(function () {
    if (typeof window === 'undefined' || !linkRef.current || !beforeIconRef.current) {
      return;
    }
    var beforeIconRect = beforeIconRef.current.getBoundingClientRect();
    var iconGap = parseInt(window.getComputedStyle(linkRef.current).getPropertyValue('--icon-gap'), 10);
    linkRef.current.style.setProperty('--leading-icon-indent', "".concat(beforeIconRect.width + iconGap, "px"));
  }, []);
  useLayoutEffect(function () {
    if (allowIconLeading && beforeIcon && !inline && linkRef.current) {
      setIconLeading();
    } else {
      resetIconLeading();
    }
  }, [allowIconLeading, beforeIcon, inline, setIconLeading, resetIconLeading]);
  return {
    linkRef: linkRef,
    beforeIconRef: beforeIconRef
  };
}